import { cn } from "@babybjorn/ui";
import type { FC } from "react";
import * as s from "./GalleryBadge.module.scss";

type GalleryBadgeProps = {
	label: string;
	isProductImage?: boolean;
};

const GalleryBadge: FC<GalleryBadgeProps> = ({ label, isProductImage }) => (
	<span className={cn(s.galleryBadge, { [s.borderRadius]: isProductImage })}>
		{label}
	</span>
);

export default GalleryBadge;
